import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Col, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function TermsServicesAddEdit() {
	const navigate = useNavigate();
	const { editTermsId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const get = () => {
		if (!editTermsId) return;

		setIsLoading(true);
		axios
			.get(`/terms-services`, { params: { _id: editTermsId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => setIsLoading(false));
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editTermsId) values._id = editTermsId;

				axios({
					method: editTermsId ? 'put' : 'post',
					url: '/terms-services',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/terms-services');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => console.log(e));
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'Terms & Services' }]} />
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editTermsId ? 'Edit Terms & Services' : 'Add Terms & Services'}</div>
						<div className='page-title-more'>
							<Link to='/terms-services'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave} loading={isLoading}>
								Save
							</Button>
						</div>
					</div>

					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Terms & Services Details',
										children: (
											<>
												<Col sm={24} md={24}>
													<Form.Item label='Title' name='title' rules={[{ required: true, message: 'Title is required' }]}>
														<Input placeholder='Enter title' />
													</Form.Item>
												</Col>

												<Col sm={24} md={24}>
													<Form.Item label='Content' name='content' rules={[{ required: true, message: 'Content is required' }]}>
														<Input.TextArea rows={10} placeholder='Enter content' />
													</Form.Item>
												</Col>
											</>
										),
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default TermsServicesAddEdit;
